export default function (col) {
  return typeof col.visible === 'undefined' || '' + col.visible === 'true'
}



// WEBPACK FOOTER //
// ./src/components/Datatable/src/_utils/isColVisible.js